import React from 'react';
import { Slider } from 'antd';
import styles from './VideoPlayer.module.scss';

interface RangeSliderProps {
  showRangeSlider: boolean;
  rangeSliderValue: [number, number];
  duration: number;
  onRangeChange: (value: [number, number]) => void;
  onRangeChangeComplete: (value: [number, number]) => void;
}

const RangeSlider: React.FC<RangeSliderProps> = ({
  showRangeSlider,
  rangeSliderValue,
  duration,
  onRangeChange,
  onRangeChangeComplete,
}) => {
  if (!showRangeSlider) return null;

  return (
    <div
      className={styles.rangeBarContainer}
      style={{
        position: 'absolute',
        left: 4,
        right: 4,
        top: 5,
        width: 'calc(100% - 16px)',
        margin: 'auto',
        height: 5,
        background: 'transparent',
        zIndex: 2,
      }}
    >
      <Slider
        range
        min={0}
        max={duration}
        step={0.01}
        className={styles.rangeSlider}
        value={rangeSliderValue}
        onChange={(value) => {
          if (Array.isArray(value) && value.length === 2) {
            onRangeChange([value[0], value[1]]);
          }
        }}
        onChangeComplete={(value) => {
          if (Array.isArray(value) && value.length === 2) {
            onRangeChangeComplete([value[0], value[1]]);
          }
        }}
        tooltip={{ formatter: v => `${v?.toFixed(2)}s` }}
        style={{ width: '100%', height: 5 }}
        trackStyle={[{ background: 'var(--app-accent-color)', height: 5 }]}
        handleStyle={[{}, {}]}
        railStyle={{ background: 'transparent', height: 5 }}
      />
    </div>
  );
};

export default RangeSlider; 